import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { driverVersions } from 'app/registries/consts/tabular-consts';
import { LinkedServiceUtils } from './linked-service.utils';

export const netezzaSecurityLevelTypes = {
    OnlyUnSecured: 'onlyUnSecured',
    preferredUnSecured: 'preferredUnSecured',
    preferredSecured: 'preferredSecured',
    onlySecured: 'onlySecured'
};
@Metamodel.model({
    name: adfModelTypeMap.netezza.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Netezza_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Netezza_DisplayText)
    ]
})
export class NetezzaLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    @Metamodel.attribute({
        display: stringResources.VersionLabel
    })
    public version?: string = driverVersions.v2;
    
    @Metamodel.attribute({
        display: stringResources.ModelName_ServerName
    })
    public server?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port
    })
    public port?: number;

    @Metamodel.attribute({
        display: stringResources.ModelName_DatabaseName
    })
    public databaseName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public password?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_SecurityLevel
    })
    public securityLevel?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_CaCertFile
    })
    public caCertFile?: string; //Deprecated, but keep it in case we need it in v2 LS

    public enableAKV?: boolean = false;
    @Metamodel.attribute({
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public referedAKV?: AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_PreFetch
    })
    public prefetch?: number = 500000;

    @Metamodel.attribute({
        display: stringResources.ModelName_Socket
    })
    public socket?: number = 4096;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public convertV1toV2(context: { inlineDataset?: boolean }): NetezzaLinkedService {
        return LinkedServiceUtils.commonV1ToV2(context, this) as NetezzaLinkedService;
    }
}
